export default "<div class=\"notice-container\">\n    <div>\n        <img src=\"assets/images/dpg/notice.png\">\n    </div>\n</div>"